/* kkumi-img-loading.js — flips the .kk-img-skel image-loading shimmer off.
 *
 * Companion to the `.kk-img-skel` rule in assets/kkumi-tokens.css: that rule
 * paints the .kk-skel shimmer across an <img>'s own box until its pixels
 * arrive. This script adds `kk-img-loaded` to every <img> the moment it
 * finishes (load OR error), which switches the shimmer off — so transparent
 * artwork doesn't glow through its see-through areas, a broken image falls
 * back to its alt text, and the animation stops running behind opaque pixels.
 *
 * Coverage is three-layered because load/error don't bubble (they DO
 * capture) and can fire before this script runs:
 *   1. capture-phase document listeners — images that finish from now on;
 *   2. an initial scan of img.complete — images that finished earlier
 *      (complete is also true after a failed decode, so nothing shimmers
 *      forever);
 *   3. a MutationObserver — JS-inserted images that were already complete
 *      at insertion (cached artwork re-used by the wishlist / recently-
 *      viewed grids never fires an in-document load event).
 * The observer callback only writes classes (attribute mutations), which a
 * childList observer never re-fires on — the FRONTEND.md observer rule.
 *
 * Product cards: a card image that FAILS (error, or complete with no pixels)
 * flips its .kk-pc__media to .kk-pc__media--empty, which swaps in the Kkumi
 * lettermark fallback (assets/kkumi-product-card-v3.css) instead of a broken
 * image icon.
 */
(function () {
  'use strict';

  function mark(img) { img.classList.add('kk-img-loaded'); }

  function cardFallback(img) {
    if (!img.classList.contains('kk-pc__img--primary')) return;
    var media = img.closest('.kk-pc__media');
    if (media) media.classList.add('kk-pc__media--empty');
  }

  function check(img) {
    if (!img.complete) return;
    mark(img);
    if (!img.naturalWidth && img.getAttribute('src')) cardFallback(img);
  }

  function scan(root) {
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) check(imgs[i]);
  }

  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') mark(t);
  }, true);
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') { mark(t); cardFallback(t); }
  }, true);

  function init() {
    scan(document);
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IMG') check(node);
          else if (node.querySelectorAll) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
